export default "__VITE_ASSET__92573412__"